export const RELOAD_GUARD_MS = 10_000;

const STORAGE_KEY = 'stale-chunk-reload-at';

let isReloading = false;

// Vite still throws the import error after the reload has started (Safari's and Firefox's
// messages are not in IGNORED_ERRORS), so Sentry's beforeSend drops events while this is set.
export const isStaleChunkReloadPending = (): boolean => isReloading;

export const registerStaleChunkReload = ({
  reload = () => window.location.reload(),
  now = Date.now,
}: { reload?: () => void; now?: () => number } = {}): (() => void) => {
  const onPreloadError = (): void => {
    const at = now();

    if (at - Number(sessionStorage.getItem(STORAGE_KEY) ?? 0) < RELOAD_GUARD_MS)
      return;

    sessionStorage.setItem(STORAGE_KEY, String(at));
    isReloading = true;
    reload();
  };
  window.addEventListener('vite:preloadError', onPreloadError);

  return () => window.removeEventListener('vite:preloadError', onPreloadError);
};
